export default __webpack_public_path__ + "book_details-grade_level.c20d28b6.png";